import React from 'react';
import { Code95CycleDataEntry } from './Code95Cycle';
import {
	AccessorKeyColumnDef,
	getCoreRowModel,
	getPaginationRowModel,
	getSortedRowModel,
	PaginationState,
	SortingState,
	useReactTable,
} from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
// @ts-expect-error image is valid
import CcvImage from '../../../../assets/images/Code95V3.svg';
import DashboardTableFooter from '../DashboardTableFooter';
import DashboardTable from '../DashboardTable';

const Table = ({
	data,
	columns,
}: {
	data: Code95CycleDataEntry[];
	columns: AccessorKeyColumnDef<Code95CycleDataEntry, string>[];
}) => {
	const [pagination, setPagination] = React.useState<PaginationState>({
		pageIndex: 0,
		pageSize: 5,
	});

	const [sorting, setSorting] = React.useState<SortingState>([
		{
			id: 'endDate',
			desc: false,
		},
	]);

	const { t } = useTranslation();
	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
		getSortedRowModel: getSortedRowModel(),
		onPaginationChange: setPagination,
		onSortingChange: setSorting,
		state: {
			pagination,
			sorting,
		},
	});

	return (
		<Card className="m-3 col-5" style={{ minHeight: 300 }}>
			<Card.Body>
				<Card.Title>
					<>
						<img style={{ height: 45 }} src={CcvImage} alt={t('code95.code95')} />
						<span className="m-2">{t('dashboard.cycle_expires')}</span>
					</>
				</Card.Title>
				<DashboardTable headerGroups={table.getHeaderGroups()} rows={table.getRowModel().rows} />
				<DashboardTableFooter
					pageIndex={table.getState().pagination.pageIndex}
					pageCount={table.getPageCount()}
					previousPage={table.previousPage}
					nextPage={table.nextPage}
					getCanPreviousPage={table.getCanPreviousPage}
					getCanNextPage={table.getCanNextPage}
					t={t}
				/>
			</Card.Body>
		</Card>
	);
};

export default Table;
